import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

export function Footer() {
  return (
    <footer className="border-t mt-24">
      <div className="max-w-6xl mx-auto py-12 px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-3">
            <h3 className="text-lg font-semibold">WhatSayUs</h3>
            <p className="text-sm text-muted-foreground">
              Making group decisions simpler through AI-powered conversations.
            </p>
          </div>
          
          <div className="space-y-3">
            <h3 className="text-lg font-semibold">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/create" className="text-sm text-muted-foreground hover:text-primary">
                  Create Decision
                </Link>
              </li>
              <li>
                <a 
                  href="/#examples"
                  className="text-sm text-muted-foreground hover:text-primary"
                >
                  Examples
                </a>
              </li>
              <li>
                <a 
                  href="/#faq"
                  className="text-sm text-muted-foreground hover:text-primary"
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div className="space-y-3">
            <h3 className="text-lg font-semibold">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-sm text-muted-foreground hover:text-primary">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-muted-foreground hover:text-primary">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          <div className="space-y-3">
            <h3 className="text-lg font-semibold">Contact</h3>
            <div className="flex items-center space-x-2">
              <Mail className="h-5 w-5 text-muted-foreground" />
              <a 
                href="mailto:hello@whatsayus.com"
                className="text-sm text-muted-foreground hover:text-primary"
              >
                {'hello'}&#64;{'whatsayus'}&#46;{'com'}
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t mt-8 pt-8 text-center text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} WhatSayUs. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}